module.exports = __webpack_public_path__ + "static/media/logo_chatbot.2bc86a0f.webp";